import { memo } from "react"
import { useNavigate } from "@tanstack/react-router"

import { useDocsTabDialogs } from "@/stores/docs/docs-tab-store"
import { DocsTabDialog } from "./docs-tab-dialog"
import { useDocsTabs } from "./use-docs-tabs"

/** The "New tab" entry of the header menu and the tab bar opens this. */
export const NewDocsTabDialog = memo(() => {
	const navigate = useNavigate()
	const { isNewTabOpen, setNewTabOpen } = useDocsTabDialogs()
	const { tabs, portalInstanceId, setActiveTabId } = useDocsTabs()
	return (
		<DocsTabDialog
			isOpen={isNewTabOpen}
			onClose={() => setNewTabOpen(false)}
			portalInstanceId={portalInstanceId}
			nextOrder={(tabs.at(-1)?.order ?? -1) + 1}
			onCreated={(tabId) => {
				setActiveTabId(tabId)
				void navigate({ to: "/edit-docs" })
			}}
		/>
	)
})
